import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart } from "chart.js/auto"
import { CategoryScale } from "chart.js";

Chart.register(CategoryScale);

export default function PatientsByDentistGraph({ patientsByDentistData }) {

    const data = {
        labels: patientsByDentistData.map((e) => e.full_name),
        datasets: [
            {
                label: 'Número de pacientes',
                data: patientsByDentistData.map((e) => e.patientsCount),
                backgroundColor: [
                    'rgb(53, 162, 235)'
                ], 
                borderColor: [
                    'rgb(53, 162, 235)'
                ],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        indexAxis: 'y',
        elements: {
            bar: {
                borderWidth: 2,
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                beginAtZero: true,
                ticks: {
                    min: 0,
                    stepSize: 50
                }
            }
        }
    };

    return (
        <>
            <Bar data={data} options={options} width={300} height={500} />
        </>
    );
}